import React, { useContext, useEffect } from "react";
import styled from "styled-components";
import { AppContext } from "../../../components/AppProvider";
import { IC } from "../../../resources/Assets";
import { requestHsptList } from "../../Reservation/Surround";

export default props => {
  const { userinfo, cfg, phonecfg } = useContext(AppContext);
  const { setSearchList, searchList, settingTrgtList, resetPaging } = props;

  const searchEvent = () => {
    // request278(userinfo, cfg, phonecfg, "HPNM", $("#tags").val(), "", setSearchList);
    resetPaging();
    requestHsptList(
      userinfo,
      cfg,
      phonecfg,
      "A",
      $("#tags").val(),
      setSearchList
    );
    $("#ui-id-1").show();
  };

  const searchEventEnter = () => {
    if (window.event.keyCode == 13) {
      resetPaging();
      requestHsptList(
        userinfo,
        cfg,
        phonecfg,
        "A",
        $("#tags").val(),
        setSearchList
      );
      $("#ui-id-1").show();
    }
  };

  const inputStyle = {
    backgroundColor: "#e8e8e8",
    borderColor: "#e8e8e8",
  };

  useEffect(() => {
    $("#tags").focusout(function () {
      // $("#ui-id-1").hide();
    });

    $("#tags").focusin(function () {
      $("#ui-id-1").show();
    });
  }, []);

  return (
    <div className="pharmacy-search green">
      <div
        className="autocomplete"
        style={{
          display: "flex",
          backgroundColor: "#f5f5f5",
          borderRadius: "7px",
        }}>
        <Input
          id="tags"
          type="text"
          className="textboxGray"
          placeholder="병원명을 입력해주세요."
          onKeyUp={() => searchEventEnter()}
        />
        <img
          src={IC.etc.IC_GRAY_SEARCH}
          style={{
            width: "20px",
            height: "20px",
            margin: "auto 21px auto auto",
          }}
          onClick={() => searchEvent()}
        />
      </div>

      <TextDiv>거리순</TextDiv>

      {/* 병원 검색 리스트 */}
      {/* { searchList && searchList.length > 0
                &&  <AutoContentLi searchList={searchList} settingTrgtList={settingTrgtList}/>
            } */}
    </div>
  );
};

const Input = styled.input`
  width: 100% !important;
  padding-right: 50px !important;
  height: 50px !important;
  border: 1px solid #f5f5f5 !important;
  border-radius: 7px !important;
  background-color: #f5f5f5 !important;
  font-size: 14px !important;
  margin-left: 21px;
`;

const TextDiv = styled.div`
  text-align: right;
  font-size: 14px !important;
  font-weight: 500;
  letter-spacing: -1.2px;
  color: #0649fb;
  opacity: 1;
  margin-bottom: 10px;
`;
